import Icon from '../components/Icon.vue'

Icon.register({
  briefcase: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M320 336C320 344.8 312.8 352 304 352H208C199.2 352 192 344.8 192 336V288H0V432C0 457.6 22.4 480 48 480H464C489.6 480 512 457.6 512 432V288H320V336zM464 128H384V80C384 54.4 361.6 32 336 32H176C150.4 32 128 54.4 128 80V128H48C22.4 128 0 150.4 0 176V256H512V176C512 150.4 489.6 128 464 128zM320 128H192V96H320V128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/briefcase.js
// module id = 4M9W
// module chunks = 144